import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var Plus = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.125 10H16.875", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 3.125V16.875", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

export { Plus as default };
//# sourceMappingURL=Plus.js.map
